import { type FC } from 'react';

import { FlowError } from '@eneco/flows/components';

import type { SummaryGenericErrorTextualData } from './summary-step.types';

interface Props {
  isNotAuthenticated: boolean;
  isNotAvailable: boolean;
  isNotFound: boolean;
  isOrderFailed: boolean;
  textualData?: SummaryGenericErrorTextualData;
}

export const SummaryStepError: FC<Props> = ({
  isNotAuthenticated,
  isNotAvailable,
  isNotFound,
  isOrderFailed,
  textualData,
}) => {
  const getNotification = () => {
    if (isNotAuthenticated) return textualData?.errorNotAuthenticatedNotification;
    if (isNotAvailable) return textualData?.errorNotAvailableNotification;
    if (isNotFound) return textualData?.errorNotFoundNotification;
    if (isOrderFailed) return textualData?.sendOrderErrorNotification;

    return textualData?.fetchOfferErrorNotification;
  };

  const getButtonLabel = () => {
    if (isNotAuthenticated) return textualData?.loginButtonText;
    if (!isNotAvailable && !isNotFound) return textualData?.tryAgainButtonText;

    return undefined;
  };

  return (
    <FlowError
      type={isNotAuthenticated ? 'AUTHENTIFICATION' : 'GENERIC'}
      textualData={{
        notification: getNotification(),
        buttonLabel: getButtonLabel(),
      }}
    />
  );
};
